import { Component, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Producto } from '../producto.model';
import { ClienteService } from '../../core/cliente.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { CategoriaProducto } from '../categoria-producto/categoria-producto.model';
import { SubcategoriaProducto } from '../subcategoria-producto/subcategoria-producto.model';
import { Sugerencia } from '../sugerencia/sugerencia.model';
import { IImage } from 'ng-simple-slideshow/src/app/modules/slideshow/IImage';
import { MatSelectChange } from '@angular/material';
import { ProductoVariante } from './producto-variante';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';
import { Proveedor } from '../proveedor/proveedor.model';
import { SecurityService } from '../../security/security.service';
import { Role } from '../../security/role/role.model';
import { ImagenDisplay } from '../dtos/imagen-display';

interface IImagenColor extends IImage {
  colorIds: number[];
}

@Component({
  selector: 'app-producto-details',
  templateUrl: './producto-details.component.html',
  styleUrls: ['./producto-details.component.scss']
})
export class ProductoDetailsComponent implements OnInit {

  @ViewChild('form') public roleForm: NgForm;
  
  producto: any;
  imagen: any;
  imageUrlArray: IImagenColor[] = [{url: '', caption: '', href: '', colorIds: []}];
  images: Observable<IImagenColor[]>;
  primera = true;
  categoriasInternas: CategoriaProducto[];
  categoriasExternas: CategoriaProducto[];
  subcategoriasInternas: SubcategoriaProducto[];
  subcategoriasExternas: SubcategoriaProducto[];
  sugerenciasInternas: Sugerencia[];
  sugerenciasExternas: Sugerencia[];
  colorSelected = [];
  variantes: ProductoVariante[];
  formStock: FormGroup;
  formCantidadMinimaLogo: FormGroup;
  formComentarioRechazo: FormGroup;
  stockNuevoIngresado: number;
  cantidadMinimaNuevaIngresada:number;
  comentarioRechazoIngresado:String;
  proveedor:Proveedor;
  user: any;
  rol: Role;
  nombreRol: string;
  imagenesDisplay:ImagenDisplay[] = [];

  constructor(
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private snackService: SnackService,
    private backendService: BackendService,
    private clienteService: ClienteService,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder,
    private authService: SecurityService,
    public router: Router  ) { }

 ngOnInit() {
    /*this.images = Observable.of(this.imageUrlArray);*/

    this.user = this.authService.user;
    this.getRol();

    this.route.data.subscribe(data => {
      this.producto = data.producto;
      console.log(this.producto)

      this.backendService.get(ProductoVariante,Producto.newPath +'variantes-producto/' + this.producto.id,null).toPromise().then(a => {
        this.variantes = a;
        
      })
      /*this.backendService.get(Proveedor,Producto.newPath +'proveedor/' + this.producto.id).toPromise().then(a => {
        this.proveedor = a;
        console.log(this.proveedor);
      })*/
      //this.proveedor = this.producto.proveedor
      this.backendService.get(ImagenDisplay, '/new-productos/imagenes-display/' + this.producto.id,null).toPromise().then(a=>{
        this.imagenesDisplay = a as ImagenDisplay[];
        
      });

      

    });

    this.formStock = this.formBuilder.group({
      stockNuevo: [undefined],
    });
    this.stockNuevoIngresado = 0;

    this.formCantidadMinimaLogo = this.formBuilder.group({
      cantidadMinimaNueva: [undefined],
    });
    this.cantidadMinimaNuevaIngresada = 0;
    this.formComentarioRechazo = this.formBuilder.group({
      comentarioRechazo: [undefined],
    });

    this.comentarioRechazoIngresado=""; 

  }

  hayDatosExternos() {
    return (this.categoriasExternas && this.categoriasExternas.length > 0) ||
            (this.subcategoriasExternas && this.subcategoriasExternas.length > 0) ||
            (this.sugerenciasExternas && this.sugerenciasExternas.length > 0);
  }

  /* async getImages(id, desc, idsColor) {
    await this.clienteService.getImagenById(id).subscribe(data => {
      const urlCreator = window.URL;
      this.imagen = this.sanitizer.bypassSecurityTrustUrl(
          urlCreator.createObjectURL(data));
          this.imageUrlArray.push({url: this.imagen.changingThisBreaksApplicationSecurity, caption: desc,
                                  href: this.imagen.changingThisBreaksApplicationSecurity, colorIds: idsColor});
          if (this.primera) {
            this.imageUrlArray.splice(0, 1);
            this.primera = false;
          }
    });
  }*/

  editar(id: number) {
    this.router.navigate(['/productos/editar', id]);
  }

  tieneImagen() {
    return !(this.imageUrlArray.length === 1 && this.imageUrlArray[0].url === '');
  }

  async aceptarTodo() {
    this.dialogService.confirm('Validar datos externos',
    '¿Está seguro que desea aceptar todos los datos externos del producto?')
    .then( res => {
      if (res) {
        this.producto.categorias = this.producto.categoriasExternas;
        this.producto.subcategorias = this.producto.subcategoriasExternas;
        this.producto.sugerencias = this.producto.sugerenciasExternas;
        this.save(res, 'aceptar');
      }
    });
  }
  async descartarTodo() {
    this.dialogService.confirm('Validar datos externos',
    '¿Está seguro que desea rechazar todos los datos externos del producto?')
    .then( res => {
      if (res) {
        this.producto.categorias = [];
        this.save(res, 'descartar');
      }
    });
  }

  validarDatos() {
    this.router.navigate([Producto.path + 'validar']);
  }

  async save(res, operation) {
    if (res) {

      this.snackService.spinner(true);

      if (this.producto.id) { // Update
        try {
          await await this.backendService.update(Producto.path + 'validarproducto/' + this.producto.id + '/' + operation, null);
          this.snackService.success('Producto validado satisfactoriamente');
          this.router.navigate([Producto.path]);
        } catch (ex) {
          if (ex[0]) {
            this.snackService.error(ex[0].details);
          } else if (ex.errors) {
            this.snackService.error(ex.errors[0].defaultMessage);
          } else {
            this.snackService.error(ex.message);
          }
        } finally {
          this.snackService.spinner(false);
        }
      }
    }
  }

  colorChange(event: MatSelectChange) {
    const selection = Array.from(event.value).map(({ id }) => id);
    this.images = Observable.of(this.imageUrlArray.filter(i => i.colorIds.map(c => selection.indexOf(c)).filter(x => x >= 0).length > 0));
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  async confirmEliminar(id: number) {
    this.dialogService.confirm('Eliminar Producto',
    '¿Está seguro que desea eliminar este producto?')
    .then( res => {
      if (res) {
        this.deleteProducto(res, id);
      }
    });
  }
  async deleteProducto(res, id) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.delete(Producto.path + 'eliminar/' + id);
        this.snackService.success('Producto eliminado correctamente');
        this.router.navigate(['/productos']);
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }

    }
  }

  agregarCodigoProducto(id: number) {
    this.router.navigate(['/productos/agregar-codigo', id]);
  }

  async saveStock(vari:ProductoVariante){
    this.snackService.spinner(true);
    try{
      
      
      await this.backendService.update(Producto.newPath +"cambio-stock/" + vari.id +"/"+this.stockNuevoIngresado ,null).then(()=>{
        this.snackService.success('Stock Actualizado Correctamente');
      })
      
      
    }catch(ex){
      this.snackService.success('Stock Actualizado Correctamente');
    }finally{
      vari.stock = this.stockNuevoIngresado.toString();
      this.snackService.spinner(false)
    }

  }

  async saveCantidadMinimaLogo(){
    this.snackService.spinner(true);
    try{
      

      await this.backendService.update(Producto.newPath +"cambio-orden-minima/" + this.producto.id + "/" +this.cantidadMinimaNuevaIngresada ,null).then(()=>{
        this.snackService.success('Cantidad Minima Logo Actualizada Correctamente');
      })
      
      
    }catch(ex){
      this.snackService.success('Cantidad Minima Logo Actualizada Correctamente');
    }finally{
      this.producto.cantidadMinimaOrden = this.cantidadMinimaNuevaIngresada;
      this.snackService.spinner(false)
    }

  }

  async getRol(){
    await this.backendService.get(Role,"/new-roles/user/"+this.user.id).toPromise().then(a =>{
      this.rol = a as Role;
      this.nombreRol = this.rol.name;
    });
  }

  async confirmRechazar() {
    console.log(this.comentarioRechazoIngresado);
    if(this.comentarioRechazoIngresado.length == 0){
      return this.snackService.error("Ingrese un Motivo de Rechazo");
    }
    this.dialogService.confirm('Rechazar Producto',
    '¿Está seguro que desea rechazar el Producto ' + (this.producto.name ? this.producto.name : '') + '?')
    .then( res => {
      if (res) {
        this.rechazarProducto(res, 'rechazar');
      }
    });
  }

  async rechazarProducto(res, operation) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.update(Producto.newPath + 'cambio-de-estado/' + this.producto.id + '/' + operation, this.comentarioRechazoIngresado);
        this.snackService.success('Producto rechazado correctamente');
        this.router.navigate(['/verificador-productos']);
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }

    }

  }

  async confirmAprobar() {
    this.dialogService.confirm('Aprobar Producto',
    '¿Está seguro que desea aprobar el Producto ' + (this.producto.name ? this.producto.name : '') + '?')
    .then( res => {
      if (res) {
        this.aprobarProducto(res, 'aprobar');
      }
    });
  }

  async aprobarProducto(res, operation) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await await this.backendService.update(Producto.newPath + 'cambio-de-estado/' + this.producto.id + '/' + operation, this.comentarioRechazoIngresado);
        this.snackService.success('Producto aprobado correctamente');
        this.router.navigate(['/verificador-productos']);
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
      }

    }

  }

  private openWindow(img: ImagenDisplay) {
    this.dialogService.imageViewer(img.name, '', img.path);
    // window.open(img.url, '_blank');
    
  }

}



// WEBPACK FOOTER //
// ./src/app/productos/producto-details/producto-details.component.ts